"use strict";
var novicell = novicell || {}; // eslint-disable-line
novicell.checkboxes =
  novicell.checkboxes ||
  new (function () {
    this.init = function () {
      let checkboxInputs = document.querySelectorAll(".ef-checkbox__input");
      if (!checkboxInputs) {
        return;
      }
      for (let i = 0; i < checkboxInputs.length; i++) {
        checkboxInputs[i].addEventListener("click", (e) => {
          const checkboxLabel = e.target.parentElement;
          let isToggled = checkboxLabel.classList.contains(
            "ef-checkbox__label--selected",
          );

          if (!isToggled) {
            checkboxInputs[i].checked = true;
            checkboxInputs[i].value = true;
            checkboxLabel.classList.add("ef-checkbox__label--selected");
          } else {
            checkboxInputs[i].checked = false;
            checkboxInputs[i].value = false;
            checkboxLabel.classList.remove("ef-checkbox__label--selected");
          }
        });
      }
    };
  })();
